export default "__VITE_ASSET__BpQp3K6R__"